import { RuleObj } from './rules'

let ruleForms;
export const ruleFn = function (rules) {
    ruleForms = RuleObj.call(this)

    const result = {};

    for (let i = 0; i < rules.length; i++) {

        const ruleName = rules[i];
        result[ruleName] = ruleForms[ruleName];
        
    }
    return result;
}